<mat-card style="height: 530px">
  <form #loginForm="ngForm">
    <mat-toolbar style="float:left;clear:both;width:100%;" color="secondary">
      <h3 style="padding-left:5px">{{ 'documentDialog.titol' | translate }}</h3>
      <div style="width:100%;float:right">
        <button mat-icon-button style="float: right; margin-right:0" (click)="close()" matTooltip="{{ 'common.tancar' | translate }}" attr.aria-label="{{ 'common.tancar' | translate }}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">close</mat-icon>
        </button>
        <button mat-icon-button style="float: right; margin-right:0" (click)="desar()" matTooltip="{{ 'common.desar' | translate }}" attr.aria-label="{{ 'common.desar' | translate }}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">save</mat-icon>
        </button>
      </div>  
    </mat-toolbar>
    <mat-card-content style="float:left;clear:both;padding: 24px 5px">
      <mat-form-field style="width:100%">
       <input matInput style="width:100%"
        placeholder="{{ 'propostaMi.camps.titol' | translate }}" name="titol" type="string"
        [(ngModel)]="editDocumentData.titol" ngDefaultControl
       />
      </mat-form-field>
      <div style="float:left;clear:left;width:100%;color:rgba(0,0,0,.54);">{{ 'documentDialog.descripcioLabel' | translate }}</div>
      <div style="float:left;clear:left;width:100%">
       <textarea matInput placeholder="{{ 'documentDialog.descripcioLabel' | translate }}" name="descripcio" rows="3" [(ngModel)]="editDocumentData.descripcio"  style="width: 100%">
       </textarea>
      </div>
      <mat-form-field style="width:50%;padding-top: 20px">
       <input matInput style="width:130px"
        placeholder="{{ 'propostaMi.camps.tipus' | translate }}" name="tipus" type="string"
        [(ngModel)]="editDocumentData.tipus" ngDefaultControl
       />
      </mat-form-field>
      <mat-form-field style="width:20%">
       <input matInput style="width:130px"
        placeholder="{{ 'propostaMi.dates.data' | translate }}" name="data_doc" type="date"
        [(ngModel)]="editDocumentData.data_doc" ngDefaultControl
       />
      </mat-form-field>
      <div style="float:left;clear:left;width:100%">
        <div style="float:left;clear:left;position: absolute;width:100%;z-index:1;background-color: white">
          <div style="float:left;clear:none;padding-top:5px;width:100%" *ngIf="editDocumentData.fitxer">{{ 'documentDialog.documentLabel' | translate }}{{editDocumentData.fitxer}}</div>
          <div style="float:left;clear:none;padding-top:15px">{{ 'ticketingDialog.carregarDocument' | translate }}</div>
          <div style="float:left;clear:none;padding-top:10px">
            <label for="fitxer">
              <mat-icon style="font-size:24px;margin-left: 20px; margin-right: 1em;cursor:pointer" color="primary"
               matTooltip="{{ 'ticketingDialog.extensioMinuscules' | translate }}" attr.aria-label="{{ 'ticketingDialog.extensioMinuscules' | translate }}" matTooltipClass="tooltip-style">cloud_upload</mat-icon>
            </label>
          </div>
        </div>
        <div style="float:left;clear:left;position: absolute;width:100%">
          <input mat-raised-button color="primary" type="file" filter="jpg;png;doc;docx;pdf;xls;xlsx;gif;zip;rar;odt;ods;ppt;pptx" style="width:80%" placeholder="" id="fitxer" name="fitxa" (change)="onFileChange($event)"/> {{ 'ticketingDialog.maxMida' | translate }}
        </div>
      </div>
    </mat-card-content>
  </form>
</mat-card>
